var codeblock_default = {
  "blockStyleSpacing": "S4uSu",
  "codeBlock": "YztqI S4uSu",
  "renderedInTable": "mCJ7n"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
